<itb-heading mat-dialog-title [className]="'modal-h'" [text]="'Configuration List'"></itb-heading>
<itb-round-button mat-dialog-close [className]="'light round-modal-cross caret-close-modal'" [iconClassName]="'cross'"> </itb-round-button>
<div mat-dialog-content>
  <itb-data-grid [columnDefs]="data.columnDefs" [rowData]="data.rowData" [rowModelType]="'clientSide'"
                 [totalRows]="data.rowData.length"></itb-data-grid>
</div>
<mat-dialog-actions>
  <itb-default-button mat-dialog-close [text]="'Cancel'" [className]="'default'" [iconClassName]="'cross'"></itb-default-button>
</mat-dialog-actions>
